import SuccessCheck from './SuccessCheck';

export default SuccessCheck;
